export default {
 		"Contact.index.547366-0": "Choose Zongheng Sihai to quickly achieve enterprise digital transformation",
		"Contact.index.547366-1": "Your title",
		"Contact.index.547366-2": "Your phone number",
		"Contact.index.547366-3": "Other contact information",
		"Contact.index.547366-4": "Submit",
		"Contact.index.547366-5": "National Consultation Hotline:",
		"Contact.index.547366-6": "Solution",
		"Contact.index.547366-7": "Software development services",
		"Contact.index.547366-8": "Industry Solutions",
		"Contact.index.547366-9": "Digital Strategy Consulting",
		"Contact.index.547366-10": "About Zongheng Sihai",
		"Contact.index.547366-11": "Company official website",
		"Contact.index.547366-12": "Zongheng Sihai official account",
		"Contact.index.547366-13": "Tiktok Number",
		"Contact.index.547366-14": "©  2026 Zongheng Sihai. All rights reserved | Shanghai ICP No. 2026002949-1",
		"Contact.index.547366-15": "Registered address: Huayang Road, Changning District, Shanghai"
}
